<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
//import login from "./components/login";
//import home from "./components/home";
export default {
  name: "App",
  components: {},
  created() {
    this.localSocket();
    /*if (this._isMobile()) {
      window.location.href = "http://mob.360mon.cn";
    } else {
      this.$router.replace("/");
    }*/
  },
  methods: {
    localSocket() {
      let that = this;
      if ("WebSocket" in window) {
        console.log("您的浏览器支持 WebSocket!");

        that.ws = new WebSocket(`ws://webser.360mon.cn:7272/`);
        that.global.setWs(that.ws);
        //that.ws.onopen = that.onopen();

        that.ws.onclose = function() {
          // 关闭 websocket
          console.log("连接已关闭...");
          setTimeout(() => {
            that.localSocket();
          }, 2000);
        };
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style scoped>
#app /deep/.el-table th {
  text-align: left;
  background: #e9e9e9;
  font-size: 13px !important;
  font-weight: bold;
  color: rgba(17, 17, 17, 1);
}
#app /deep/.el-table td {
  text-align: left;
}
</style>
